// ** React Imports
import React from "react";

// ** Third Party Imports
import DataTable from "react-data-table-component";
import { useIntl } from "react-intl";

const Datatable = props => {
    // ** Hooks
    const intl = useIntl();

    return (
        <DataTable
            highlightOnHover
            noDataComponent={intl.formatMessage({id: "datatable.noDataComponent"})}
            noHeader
            pagination
            paginationComponentOptions={{
                rowsPerPageText: intl.formatMessage({id: "datatable.rowsPerPageText"}),
                rangeSeparatorText: intl.formatMessage({id: "datatable.rangeSeparatorText"}),
                noRowsPerPage: false,
                selectAllRowsItem: false,
                selectAllRowsItemText: intl.formatMessage({id: "datatable.selectAllRowsItemText"})
            }}
            pointerOnHover
            {...props}
        />
    )
}

export default Datatable;
